import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRelationLeft = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 50,
	viewBox: "0 0 24 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 14C11 12.3431 12.3431 11 14 11H21C21.5523 11 22 11.4477 22 12V12C22 12.5523 21.5523 13 21 13H14C13.4477 13 13 13.4477 13 14V36C13 36.5523 13.4477 37 14 37H21C21.5523 37 22 37.4477 22 38V38C22 38.5523 21.5523 39 21 39H14C12.3431 39 11 37.6569 11 36V14Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 21.3018,
			cy: 38,
			r: 2.69819,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.4095 13.4142L19.874 16.9497C19.4834 17.3403 18.8503 17.3403 18.4597 16.9497V16.9497C18.0692 16.5592 18.0692 15.9261 18.4597 15.5355L20.5811 13.4142C21.3621 12.6332 21.3621 11.3668 20.5811 10.5858L18.4597 8.46447C18.0692 8.07394 18.0692 7.44078 18.4597 7.05025V7.05025C18.8503 6.65973 19.4834 6.65973 19.874 7.05025L23.4095 10.5858V10.5858C24.1905 11.3668 24.1905 12.6332 23.4095 13.4142V13.4142Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgRelationLeft);
export { ForwardRef as ReactComponent };
